<template>
  <v-sheet :light="true" min-height="400" min-width="600">
    <base-assignment
      :available="available"
      :selected="selected"
      @save="save"
    ></base-assignment>
  </v-sheet>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import BaseAssignment from "@/components/BaseAssignment"
import { mapGetters } from "vuex"

export default {
  mixins: [eventMixin],
  components: {
    BaseAssignment
  },
  props: {
    userId: { type: Number }
  },
  data: function() {
    return {
      available: [],
      selected: []
    }
  },
  computed: {
    ...mapGetters("documents", ["getSelected", "getAvailable"])
  },
  created() {
    this.selected = this.getSelected
    this.available = this.getAvailable.filter(
      el => !this.selected.map(el => el.id).includes(el.id)
    )
  },
  methods: {
    save({ available, selected, newAsCopy }) {
      this.overlay = false
      this.$store.dispatch("documents/assignDocuments", {
        userId: this.userId,
        documentIds: selected.map(el => el.id)
      })

      this.$emit("save", { available, selected, newAsCopy })
    }
  }
}
</script>
